import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import ArcoVue from '@arco-design/web-vue'
import '@arco-design/web-vue/dist/arco.css'
import '@/assets/dark-theme.css'
import '@/assets/mobile.css'

// 应用持久化的深色模式（Arco 使用 body 的 arco-theme 属性）
if (localStorage.getItem('arco-theme') === 'dark') {
  document.body.setAttribute('arco-theme', 'dark')
}

const app = createApp(App)
app.use(ArcoVue)
app.use(store)
app.use(router)
app.mount('#app')
